import { ref, watch, onMounted, onUnmounted, inject } from 'vue'

/**
 * 버튼 스크롤 이벤트 관련 함수
 */
export const useScroll = () => {
  const sectionRef = ref(null)
  const checkSectionRef = ref(null)
  const buttonRef = ref(null)

  const sectionClass = ref('pb-80')
  const buttonClass = ref('')
  const buttonHiddenClass = ref('')

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          buttonHiddenClass.value = 'hidden-btn-apply'
        } else {
          buttonHiddenClass.value = ''
        }
      })
    },
    { threshold: 0.1 }
  )

  const scrollHandler = () => {
    if (!sectionRef.value || !buttonRef.value) return

    const buttonRect = buttonRef.value.getBoundingClientRect()
    const sectionRect = sectionRef.value.getBoundingClientRect()
    const heighHeader = document.querySelector('header').offsetHeight
    const remToPixels = 1 * parseFloat(getComputedStyle(document.documentElement).fontSize)

    if (sectionRect.bottom - remToPixels - heighHeader - buttonRect.height < 0) {
      buttonClass.value = 'fixed'
      sectionClass.value = 'pb-140'
    } else {
      buttonClass.value = ''
      sectionClass.value = 'pb-80'
    }
  }

  onMounted(() => {
    observer.observe(checkSectionRef.value)
    document.addEventListener('scroll', scrollHandler)
  })

  onUnmounted(() => {
    observer.disconnect()
    document.removeEventListener('scroll', null)
  })

  return {
    sectionRef,
    checkSectionRef,
    buttonRef,
    sectionClass,
    buttonClass,
    buttonHiddenClass
  }
}

/**
 * 슬라이드 관련 함수
 */
export const useSlide = () => {
  const swiperRef = ref(null)
  const prevDisabled = ref(true)
  const nextDisabled = ref(false)

  const onSlideChange = e => {
    const isBeginning = e.isBeginning
    const isEnd = e.isEnd

    if (isBeginning) prevDisabled.value = true
    else prevDisabled.value = false

    if (isEnd) nextDisabled.value = true
    else nextDisabled.value = false
  }

  const slidePrev = () => {
    swiperRef.value.$el.swiper.slidePrev()
  }

  const slideNext = () => {
    swiperRef.value.$el.swiper.slideNext()
  }

  return {
    prevDisabled,
    nextDisabled,
    swiperRef,
    onSlideChange,
    slidePrev,
    slideNext
  }
}

/**
 * 모달 관련 함수
 */
export const useModal = () => {
  const modalState = ref(false)

  const openModal = () => {
    modalState.value = true
  }

  const closeModal = () => {
    modalState.value = false
  }

  watch(modalState, value => {
    value ? (document.body.style.overflow = 'hidden') : document.body.style.removeProperty('overflow')
  })

  return {
    modalState,
    openModal,
    closeModal
  }
}

/**
 * 탭 관련 함수
 */
export const useTab = mobileFn => {
  const mobileCheck = inject('mobileCheck')
  const tab = ref(0)

  const handleTabClick = index => {
    if (mobileCheck.value) mobileFn?.()

    tab.value = index
  }

  return {
    tab,
    handleTabClick
  }
}
